import { daisukeAuth0Store } from '@tsyl/daisuke-auth-plugin'

export function requireBenderAccess(): boolean | string {
  return daisukeAuth0Store().hasPermission('bender') ? true : '/'
}
